import { render, staticRenderFns } from "./DetailPurchaseDownPayment.vue?vue&type=template&id=5f3d97a3"
import script from "./DetailPurchaseDownPayment.vue?vue&type=script&lang=js"
export * from "./DetailPurchaseDownPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports